<template>
  <div>
    <nav aria-label="breadcrumb">
      <ol class="breadcrumb">
        <li class="breadcrumb-item">
          <a href="#">{{ translations('navbar.sale_management') }}</a>
        </li>
        <li class="breadcrumb-item active" aria-current="page">{{translations('navbar.archive_reserve')}}</li>
      </ol>
    </nav>
    <div class="container-fluid main-container">
      <div class="form-inline mb-4 justify-content-between">
        <div class="d-flex flex-wrap">
          <div class="form-group mr-2">
            <button class="btn btn-primary" type="button" data-toggle="modal" @click="addReserves()" disabled>{{translations('common.addition')}}</button>
          </div>
          <div class="form-group mr-1">
            <input id='dtSearch' type="text" class="form-control" v-model='dtSearch' :placeholder="translations('common.keyword_search')">
          </div>
          <div class="form-group mr-3">
            <v-select
              :value="billings.find(m => m.id === client_id) || ''"
              :options="billings"
              label="name"
              :placeholder="translations('order.billing_address')"
              :id="client_id"
              @input="changedMasterBilling">
            </v-select>
          </div>
          <div class="form-group mr-3 d-flex flex-wrap">
            <span class="mr-1">{{translations('common.period')}}</span>
<!--            <input v-model="startDate" type="date" class="form-control" @blur='triggerDateFilter("startDate")' @focus="tempDateField = startDate">-->
            <input v-model="startDate" type="date" class="form-control">
            <span class="mr-1 ml-1">〜</span>
<!--            <input v-model="endDate" type="date" class="form-control" @blur='triggerDateFilter("endDate")' @focus="tempDateField = endDate">-->
            <input v-model="endDate" type="date" class="form-control">
          </div>
          <div class="form-group mr-3">
            <div class="dropdown">
              <button id='filterByBilling' class="btn btn-outline-secondary dropdown-toggle" type="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                {{ getShipmentStatusReserveTxt (translatedShipmentStatusList, status_reserve_id, 'name', translations('reserve.display_all')) }}
              </button>
              <div class="dropdown-menu">
                <a class='dropdown-item' v-for='(status, i) in translatedShipmentStatusList' :key='i' v-on:click='status_reserve_id=status.id'>{{ status.name }}</a>
              </div>
            </div>
          </div>
          <div class="form-group ml-2">
            <div class="form-check">
              <input v-model="displayAll" class="form-check-input pointer-clickable" id="displayAll" type="checkbox" value="" >
              <label class="form-check-label pointer-clickable" for="displayAll">
                {{ translations('common.display_all') }}
              </label>
            </div>
          </div>
          <div class="form-group ml-2">
            <button class="btn btn-primary btn-sm" type="button" @click="submitSearch">{{translations('common.search')}}</button>
          </div>
        </div>
        <div class="form-inline justify-content-end" style="float:right;">
          <div class="form-group" style="margin: 1px 10px 0 0">
            <button class="btn btn-primary btn-sm" type="button" @click="exportCsv">{{translations('common.csv_export')}}</button>
          </div>
          <div class="form-group mr-3">
            <span class="font-weight-bold mb-0" style="font-size:15px;">{{ translations('reserve.total_reserve_quantity') }}： {{ totalQuantity.toLocaleString() }}  </span>
          </div>
          <div class="form-group mr-3">
            <span class="font-weight-bold mb-0" style="font-size:15px;">{{ translations('reserve.total_reserve_amount') }}： {{ totalAmount.toLocaleString() }}  </span>
          </div>
          <div class="form-group">
            <span class="font-weight-bold mb-0" style="font-size:15px;">{{ translations('reserve.gross_profit_total') }}： {{ (totalAmount-totalCost).toLocaleString() }}  </span>
          </div>
        </div>
      </div>
      <div class="table-scroll mb-4">
        <v-data-table
          class="table table-striped table-hover table-1500 table-clickable table-no-margin"
          item-key="name"
          :headers="translatedHeader"
          :items="orders"
          :options.sync="options"
          :server-items-length="totalCount"
          hide-default-footer
          @page-count="pageCount = $event"
        >
          <template v-slot:body="{ items }">
            <tbody class="nowrap">
              <template v-if="!isEmpty">
                <tr  v-for="(order, i) in items" :key='i' data-href="" @click="openSingleOrders(order)">
                  <td>{{i + 1}}</td>
                  <td>
                    <span class="badge" :class="getStatusClass(order.order_status)">
                      {{ getStatusLabel(order.order_status) }}
                    </span>
                  </td>
                  <td>{{ $invoiceTools.formatDate(order.order_at) }}</td>
                  <td>{{ order.order_number }}</td>
                  <td>
                    <ul v-if="!allShipNumbersEmpty(order.details)">
                      <li v-for="(detail, i) in order.details" :key="i">{{ detail.ship_number || '-' }}</li>
                    </ul>
                    <span v-else>-</span>
                  </td>
                  <td>{{ order.division_type === 'B' ? order.warehouseKaiShuFromName : order.client_name}}</td>
                  <td>
                    <ul>
                      <li v-for="(detail, i) in order.details" :key="i">{{detail.jan_code || '&nbsp;'}}</li>
                    </ul>
                  </td>
                  <td>
                    <ul>
                      <li v-for="(detail, i) in order.details" :key="i">{{detail.type_number || detail.omission_name || '&nbsp;'}}</li>
                    </ul>
                  </td>
                  <td class="right">
                    <ul>
                      <li v-for="(detail, i) in order.details" :key="i">{{detail.quantity.toLocaleString()}}</li>
                    </ul>
                  </td>
                  <td class="right">
                    <ul>
                      <li v-for="(detail, i) in order.details" :key="i">
                        <span v-if="Number(detail.tax_status) === 2">{{ detail.unit_price_inctax.toLocaleString() }}</span>
                        <span v-else>{{ detail.unit_price.toLocaleString() }}</span>
                      </li>
                    </ul>
                  </td>
                  <td class="right">
                    <ul>
                      <li v-for="(detail, i) in order.details" :key="i">{{detail.total_quantity_shipped.toLocaleString()}}</li>
                    </ul>
                  </td>
                  <td class="right">
                    <ul>
                      <li v-for="(detail, i) in order.details" :key="i">{{detail.remain_quantity.toLocaleString()}}</li>
                    </ul>
                  </td>
                  <td>
                    <ul>
                      <li v-for="(detail, i) in order.details" :key="i">{{detail.client_order_number || '&nbsp;'}}</li>
                    </ul>
                  </td>
                  <td>
                    <ul>
                      <li v-for="(detail, i) in order.details" :key="i">{{sliceNote(detail.internal_memo) || '&nbsp;'}}</li>
                    </ul>
                  </td>
                  <td class="right">{{ order.total_amount.toLocaleString() }}</td>
                   <td>{{ order.division_type === 'B' ? order.warehouseKaiShuName : order.destination_name}}</td>
                  <td>{{ sliceNote(order.note) }}</td>
                  <td>
                    <ul>
                      <li v-for="(detail, i) in order.details" :key="i">{{detail.remarks || '&nbsp;'}}</li>
                    </ul>
                  </td>
                  <td><DivisionTypeText :division_type="order.division_type" :labelDefault="null" /></td>
                  <td>{{ order.memo }}</td>
                </tr>
              </template>
              <template v-else>
                <tr class="odd">
                  <td valign="top" colspan="12" class="dataTables_empty">{{ isEmptyMsg }}</td>
                </tr>
              </template>
            </tbody>
          </template>
        </v-data-table>
      </div>
      <v-pagination v-model="page" :length="pageCount" :total-visible="11"></v-pagination>
    </div>
    <vue-element-loading :active="isSearching" :is-full-screen="true"/>
    <ArchiveOrdersModal @add="initList"/>
  </div>
</template>

<script>
import VueElementLoading from 'vue-element-loading'
import ArchiveOrdersModal from '@/components/ArchiveOrdersModal'
import DivisionTypeText from '@/components/orders/DivisionTypeText'
import { DivisionType, OrderStatus } from '@/constants'
import { mapState } from 'vuex'
import { saveAs } from 'file-saver'
import Papa from 'papaparse'
import encoding from 'encoding-japanese'

export default {
  name: 'ArchiveReserves',
  props: {},
  components: {
    VueElementLoading,
    ArchiveOrdersModal,
    DivisionTypeText
  },
  data () {
    return {
      orders: [],
      client_id: 0,
      dtSearch: '',
      isSearching: false,
      isEmpty: false,
      isEmptyMsg: '',
      endDate: '',
      startDate: '',
      // tempDateField: '',
      page: 1,
      pageCount: 0,
      totalCount: 0,
      totalAmount: 0,
      totalQuantity: 0,
      totalCost: 0,
      options: {
        page: 1,
        itemsPerPage: 10,
        sortBy: [],
        sortDesc: [],
        groupBy: [],
        groupDesc: [],
        multiSort: false,
        mustSort: false
      },
      status_reserve_id: 0,
      displayAll: false
    }
  },
  computed: {
    ...mapState(['currentLanguage']),
    billings () {
      return this.$store.getters['Master/getBillTo']
    },
    translatedShipmentStatusList () {
      const shipmentStatusList = [
        { id: 4, name: 'reserve.display_all' },
        { id: 6, name: 'reserve.not_ship' },
        { id: 7, name: 'reserve.reserve_completed' },
        { id: 8, name: 'reserve.partial_shipment' }
      ]
      return shipmentStatusList.map(status => ({
        ...status,
        name: this.translations(status.name)
      }))
    },
    translatedHeader () {
      if (this.status_reserve_id === 8) {
        const headers = [
          { text: 'No', sortable: false },
          { text: 'order.order_status', value: 'order_status' },
          { text: 'order.order_date', value: 'ordered_at' },
          { text: 'reserve.order_number', value: 'order_number' },
          { text: 'sale.ship_number', value: 'ship_number' },
          { text: 'reserve.bill_to', value: 'younosuke_company_name' },
          { text: 'reserve.jan_code', value: 'jan_code' },
          { text: 'reserve.model', value: 'model' },
          { text: 'reserve.reserve_balance', value: 'quantity' },
          { text: 'reserve.unit_price', value: 'unit_price' },
          { text: 'reserve.number_shipments', value: 'total_quantity_shipped', sortable: false },
          { text: 'order.remain_quantity', value: 'remain_quantity' },
          { text: 'reserve.client_order_number', value: 'client_order_number' },
          { text: 'reserve.product_internal_memo', value: 'internal_memo' },
          { text: 'reserve.total_amount', value: 'total_amount' },
          { text: 'reserve.destination_name', value: 'destination_name' },
          { text: 'reserve.internal_memo', value: 'note' },
          { text: 'reserve.summary', value: 'remarks' },
          { text: 'reserve.division', value: 'division_type' },
          { text: 'reserve.remarks', value: 'memo' }
        ]

        return headers.map(header => ({
          ...header,
          text: this.translations(header.text)
        }))
      }
      const headers = [
        { text: 'No', sortable: false },
        { text: 'order.order_status', value: 'order_status' },
        { text: 'order.order_date', value: 'ordered_at' },
        { text: 'reserve.order_number', value: 'order_number' },
        { text: 'sale.ship_number', value: 'ship_number' },
        { text: 'reserve.bill_to', value: 'younosuke_company_name' },
        { text: 'reserve.jan_code', value: 'jan_code' },
        { text: 'reserve.model', value: 'model' },
        { text: 'reserve.reserve_quantity', value: 'quantity' },
        { text: 'reserve.unit_price', value: 'unit_price' },
        { text: 'reserve.number_shipments', value: 'total_quantity_shipped', sortable: false },
        { text: 'order.remain_quantity', value: 'remain_quantity' },
        { text: 'reserve.client_order_number', value: 'client_order_number' },
        { text: 'reserve.product_internal_memo', value: 'internal_memo' },
        { text: 'reserve.total_amount', value: 'total_amount' },
        { text: 'reserve.destination_name', value: 'destination_name' },
        { text: 'reserve.internal_memo', value: 'note' },
        { text: 'reserve.summary', value: 'remarks' },
        { text: 'reserve.division', value: 'division_type' },
        { text: 'reserve.remarks', value: 'memo' }
      ]

      return headers.map(header => ({
        ...header,
        text: this.translations(header.text)
      }))
    }
  },
  watch: {
    // client_id () {
    //   this.initList()
    // },
    // status_reserve_id () {
    //   this.initList()
    // },
    page () {
      this.getFilterdList()
    },
    options: {
      handler () {
        let visitCount = Number(localStorage.getItem('visitCountReserves')) || 0
        if (visitCount > 0) {
          this.initList()
        }
      },
      deep: true
    }
  },
  created: function () {
    this.$store.dispatch('Master/checkBillTo')
    let storedFilter = this.$storage.get('ArchiveReservesParam')

    if (storedFilter) {
      this.dtSearch = storedFilter.search
      this.client_id = storedFilter.client_id
      this.startDate = storedFilter.start_at
      this.endDate = storedFilter.end_at
      this.isShowShipped = storedFilter.show_shipped
      this.options.sortBy = storedFilter.orderbys
      this.options.sortDesc = storedFilter.is_descs
      this.status_reserve_id = storedFilter.status_id
    }
  },
  methods: {
    translations (key) {
      const language = require(`@/locales/${this.currentLanguage}.json`)
      const keys = key.split('.')
      let value = language

      for (const k of keys) {
        value = value[k]
        if (!value) break
      }

      return value || key
    },
    getStatusClass (status) {
      if (Number(status) === OrderStatus.NOT_RESERVED) {
        return 'badge-light'
      } else if (Number(status) === OrderStatus.RESERVE_COMPLETED) {
        return 'badge-dark'
      }
      return 'badge-warning'
    },

    getStatusLabel (status) {
      if (Number(status) === OrderStatus.NOT_RESERVED) {
        return this.translations('reserve.unreserved')
      } else if (Number(status) === OrderStatus.RESERVE_COMPLETED) {
        return this.translations('reserve.reserve_completed')
      }
      return this.translations('reserve.partial_shipment')
    },

    getFilterTxt (obj, input, output, _default) {
      if (input) {
        if (input === 0) return _default
        return this.$invoiceTools.getObjPropsById(obj, input, output)
      }
      return _default
    },

    getShipmentStatusReserveTxt (obj, input, output, _default) {
      if (input) {
        if (input === OrderStatus.ORTHER_SHIPPING || input === OrderStatus.ALL) return _default
        return this.$invoiceTools.getObjPropsById(obj, input, output)
      }
      return _default
    },

    // changeSearch (e) {
    //   console.log(e.target.value)
    //   this.$storage.set('ArchiveOrders:dtSearch', e.target.value) // KEEP KEYWORD
    //   this.initList()
    // },

    // triggerDateFilter (source) {
    //   if (source === 'startDate' && this.startDate !== this.tempDateField) {
    //     this.initList()
    //   }
    //
    //   if (source === 'endDate' && this.endDate !== this.tempDateField) {
    //     this.initList()
    //   }
    // },

    initList () {
      if (this.page !== 1) {
        this.page = 1
      } else {
        this.getFilterdList()
      }
    },

    getFilterdList () {
      if (this.displayAll) {
        this.$storage.set('reserve_display_all', this.displayAll)
        this.options.itemsPerPage = -1 // DISPLAY ALL
      } else {
        this.options.itemsPerPage = 10 // DISPLAY 10 ROWS
      }

      if (this.isSearching) {
        return
      }

      this.isSearching = true

      const offset = (this.page - 1) * this.options.itemsPerPage
      const limit = this.options.itemsPerPage
      const orderbys = JSON.parse(JSON.stringify(this.options.sortBy))
      const isDescs = JSON.parse(JSON.stringify(this.options.sortDesc))

      let params = {
        client_id: this.client_id,
        start_at: this.startDate,
        end_at: this.endDate,
        offset: offset,
        limit: limit,
        orderbys: orderbys,
        is_descs: isDescs,
        search: this.dtSearch,
        status_id: this.status_reserve_id
      }

      this.$storage.set('ArchiveReservesParam', params)
      console.log('ArchiveReserves:getFilterdOrderList: ', params)

      return this.$http.post(this.$api_url.reserve_list, params).then(response => {
        const result = response.data
        if (result.status === true) {
          this.isEmpty = false
          this.isEmptyMsg = ''
          this.orders = result.list
          localStorage.setItem('visitCountReserves', this.orders.length)
          this.totalCount = Number(result.total_count)
          this.totalAmount = Number(result.total_amount)
          this.totalQuantity = Number(result.total_quantity)
          this.totalCost = Number(result.total_cost)
        } else {
          this.orders = []
          this.$toastr.error(result.message, this.translations('common.error'))
        }
      }).catch(e => {
        console.log('ArchiveReserves:API:getFilterdList: error: ', e)
        this.isEmpty = true
        this.isEmptyMsg = this.translations('reserve.notice_failed')
        this.$toastr.error(this.isEmptyMsg, this.translations('common.error'))
      }).finally(() => {
        this.isSearching = false
        this.$nextTick(() => {
          this.$vuetify.goTo('.table-scroll', { duration: 0 })
        })
      })
    },

    openSingleOrders (order) {
      this.$router.push({ name: 'single-reserves', query: { orders_id: order.orders_id } })
    },

    changedMasterBilling (event) {
      if (!event) {
        this.client_id = 0
        return
      }
      this.client_id = event.id
    },

    addReserves () {
      this.$router.replace('/new-reserves')
    },

    sliceNote (note) {
      let text = ''
      if (note) {
        let noteLength = note.length
        text = noteLength > 15 ? note.slice(0, 15) + '.....' : note
      }
      return text
    },

    submitSearch () {
      this.initList()
    },

    allShipNumbersEmpty (orderDetail) {
      return orderDetail.every(detail => !detail.ship_number)
    },

    exportCsv () {
      if (this.isSearching) {
        return
      }
      this.isSearching = true

      let params = {
        client_id: this.client_id,
        start_at: this.startDate,
        end_at: this.endDate,
        search: this.dtSearch,
        status_id: this.status_reserve_id
      }
      return this.$http.post(this.$api_url.reserves_csv, params).then(response => {
        const result = response.data
        if (result.status) {
          this.saveCsv_(result.list)
        }
      }).catch(e => {
        this.isEmpty = true
        this.isEmptyMsg = 'エラーのため失敗しました。ご確認後、再試行してください。'
        this.$toastr.error(this.isEmptyMsg, 'エラー')
      }).finally(() => {
        this.isLoading = false
      })
    },
    saveCsv_ (list) {
      const data = []
      list.forEach(item => {
        const divisionTypeObj = DivisionType.find(type => type.value === item.division_type)
        item.details.forEach(detail => {
          data.push([
            this.getStatusLabel(item.order_status),
            item.order_at,
            item.order_number,
            item.ship_number,
            item.client_name,
            detail.jan_code,
            detail.type_number,
            detail.quantity,
            Number(detail.tax_status) === 2 ? detail.unit_price_inctax : detail.unit_price,
            detail.total_quantity_shipped,
            detail.remain_quantity,
            detail.client_order_number,
            detail.internal_memo,
            item.total_amount,
            item.destination_name,
            item.note,
            detail.remarks,
            divisionTypeObj ? divisionTypeObj.label : '',
            item.memo
          ])
        })
      })
      let csv = ''
      csv = Papa.unparse({
        fields: [
          this.translations('order.order_status'),
          this.translations('order.order_date'),
          this.translations('reserve.order_number'),
          this.translations('sale.ship_number'),
          this.translations('reserve.bill_to'),
          this.translations('reserve.jan_code'),
          this.translations('reserve.model'),
          this.translations('reserve.reserve_quantity'),
          this.translations('reserve.unit_price'),
          this.translations('reserve.number_shipments'),
          this.translations('order.remain_quantity'),
          this.translations('reserve.client_order_number'),
          this.translations('reserve.product_internal_memo'),
          this.translations('reserve.total_amount'),
          this.translations('reserve.destination_name'),
          this.translations('reserve.internal_memo'),
          this.translations('reserve.summary'),
          this.translations('reserve.division'),
          this.translations('reserve.remarks')
        ],
        data: data
      })
      const unicodeList = encoding.stringToCode(csv)
      const sjisArray = encoding.convert(unicodeList, 'SJIS', 'UNICODE')
      const uInt8List = new Uint8Array(sjisArray)
      const content = new Blob([uInt8List], { type: 'text/csv' })
      const d = new Date()
      const filename = this.translations('reserve.reserve_') + d.getFullYear() +
        ('0' + (d.getMonth() + 1)).slice(-2) +
        ('0' + d.getDate()).slice(-2) + '_' +
        ('0' + d.getHours()).slice(-2) +
        ('0' + d.getMinutes()).slice(-2) +
        ('0' + d.getSeconds()).slice(-2) + '.csv'
      saveAs(content, filename)
      this.isSearching = false
    }
  }
}
</script>

<style>
#tbl-orders_wrapper .col-sm-12{
  padding-right: 0 !important;
}
</style>
